<template>
  <Transition name="fade">
    <div v-if="isVisible" class="global-loading-overlay">
      <div class="loading-content">
        <ArrowClockwise :size="16" color="white" class="loading-icon" />
        <p class="loading-text">{{ t("messages.loading") }}</p>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import { useStore } from "@/store";
  import { useI18n } from "vue-i18n";
  import ArrowClockwise from "@/components/icon/ArrowClockwise.vue";

  const store = useStore();
  const { t } = useI18n();

  const isVisible = computed(() => store.getters.loading);
</script>

<style lang="scss" scoped>
  .global-loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999; // Highest z-index to be on top
    backdrop-filter: blur(2px);
  }

  .loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  // Loading icon animation styles
  .loading-icon {
    margin-right: 8px;
    animation: clockwise-spin 1.2s linear infinite;
  }

  @keyframes clockwise-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .loading-text {
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    text-align: center;
  }
</style>
